import {Component} from '@angular/core';

import {ControlWidget} from '../../widget';

@Component({
  selector: 'sf-string-widget',
  templateUrl: './sf-string-widget.component.html'
})
export class StringWidgetComponent extends ControlWidget {

  getInputType() {
    if (!this.schema.widget.id || this.schema.widget.id === 'string') {
      return 'text';
    } else {
      return this.schema.widget.id;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/schema-form/components/defaultwidgets/string/sf-string-widget.component.ts